import {
  textStyleWeightOptions,
  textStyleWeightStyleOptions
} from '../../../../../fundamentals/text-styles/constants.js'
import NotificationUserAvatar from './notification-user-avatar.jsx'
import { Projects } from '../../../../../atoms/icons/menu/index.js'
import BadgesComponent from '../../../../../atoms/badges/index.jsx'
import {
  badgeSizeOptions,
  badgesVariantOptions
} from '../../../../../atoms/badges/constants.js'
import { defineDateText } from '../../../utils.js'
import MarkdownBoldText from './notification-markdown-message.jsx'
import { useIntl } from 'react-intl'
import { useCallback, useState } from 'react'
import {
  NotificationDateContainer,
  NotificationDot
} from '../../../styled-components.js'
import ListItemComponent from '../../../../../molecules/list-items/index.jsx'
import ContextMenuComponent from '../../../../context-menu/index.jsx'
import colorsOptions from '../../../../../fundamentals/colors-styles/constants.js'

const metadataNotifications = [
  'TASK_DUE_TOMORROW',
  'TASK_DUE_TODAY',
  'TASK_DUE_YESTERDAY'
]

const NotificationDateText = ({ date, read }) => {
  return (
    <NotificationDateContainer>
      <span>{date}</span>
      {!read && <NotificationDot />}
    </NotificationDateContainer>
  )
}

const NotificationListItem = ({
  item,
  index,
  onClickNotification,
  accessSearchParam
}) => {
  const { formatMessage, locale } = useIntl()

  const [hover, setHover] = useState(false)
  const [clicked, setClicked] = useState(false)

  const message = <MarkdownBoldText text={item.localizedMessage} />
  const defineDate = defineDateText(item.created, formatMessage, locale)

  const projectName = (
    <BadgesComponent
      size={badgeSizeOptions.SMALL}
      variant={badgesVariantOptions.STRONG}
    >
      <Projects /> {item.projectName ?? ''}
    </BadgesComponent>
  )

  const notificationDate = (
    <NotificationDateText date={defineDate} read={item.read} />
  )

  const isFirstItem = index === 0

  const customStyles = {
    border: 'none',
    padding: '0',
    cursor: 'pointer',
    borderRadius: 0,
    backgroundColor: clicked
      ? colorsOptions.greys['grey-10']
      : hover
        ? colorsOptions.greys['grey-05']
        : 'inherit'
  }

  const handleUserAvatar = useCallback(() => {
    if (
      item.metadata &&
      metadataNotifications.some((value) => value === item.code)
    ) {
      const user = {
        id: item.metadata.taskAssigneeId,
        name: item.metadata.taskAssignee,
        type: item.metadata.taskAssigneeType
      }
      return (
        <NotificationUserAvatar
          user={user}
          isFirstItem={isFirstItem}
          accessSearchParam={accessSearchParam}
        />
      )
    }

    return (
      <NotificationUserAvatar
        user={item.createdBy}
        isFirstItem={isFirstItem}
        accessSearchParam={accessSearchParam}
      />
    )
  }, [item, isFirstItem, accessSearchParam])

  return (
    <>
      <ListItemComponent.Item
        itemKey="notification"
        id={projectName}
        date={notificationDate}
        title={message}
        titleStyle={{
          ...textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]
        }}
        leadingIcon={handleUserAvatar()}
        onClick={() => onClickNotification(item)}
        style={customStyles}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        onMouseDown={() => setClicked(true)}
        onMouseUp={() => setClicked(false)}
      />

      <ContextMenuComponent.Divider />
    </>
  )
}

export default NotificationListItem
